import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

type MovieCardProps = {
  movie: Movie;
  showSummary?: boolean;
};

export default function MovieCard({ movie, showSummary = false }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-accent-400"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-primary-900">
        <img
          src={movie.cover}
          alt={`${movie.title} ${movie.year} 电影封面`}
          title={`${movie.title} · ${movie.genres.join(" ")} 高清影视资料`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-primary-950/85 via-primary-950/10 to-transparent opacity-90" />

        <span className="absolute left-2.5 top-2.5 rounded-md bg-background-50/95 px-2 py-0.5 font-label text-[11px] font-semibold text-foreground-900">
          {movie.year}
        </span>

        <span className="absolute right-2.5 top-2.5 flex items-center gap-1 rounded-md bg-accent-500 px-1.5 py-0.5 font-label text-[11px] font-semibold text-background-50">
          <i className="ri-star-fill text-[10px]" />
          {movie.rating.toFixed(1)}
        </span>

        <div className="absolute inset-x-0 bottom-0 p-3">
          <div className="mb-1.5 flex flex-wrap gap-1">
            {movie.genres.slice(0, 2).map((genre) => (
              <span
                key={genre}
                className="rounded-full border border-background-50/25 px-2 py-[1px] text-[10px] text-background-100"
              >
                {genre}
              </span>
            ))}
          </div>
          <h3 className="truncate font-heading text-sm font-semibold text-background-50">
            {movie.title}
          </h3>
          <p className="mt-0.5 truncate font-label text-[10px] uppercase tracking-[0.12em] text-background-300">
            {movie.subtitle}
          </p>
        </div>

        <span className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-background-50/90 text-primary-600">
            <i className="ri-play-fill text-xl" />
          </span>
        </span>
      </div>

      {showSummary && (
        <div className="p-3">
          <p className="clamp-2 text-xs leading-relaxed text-foreground-600">{movie.summary}</p>
        </div>
      )}
    </Link>
  );
}